import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Sandwich";
const Sandwich = memo(themed(Icon));
export {
  Sandwich
};
//# sourceMappingURL=sandwich.js.map
